/** Single source of public entity facts. Keep claims factual and consistent. */
export const ENTITY = {
  brand: "LeadXkids",
  legalName: "LeadXKids OPC Private Limited",
  category: "story-based life-skills learning platform",
  audience: "children aged 8–14",
  ageMin: 8,
  ageMax: 14,
  geography: "India",
  founder: "Anvith Murthy",
  format: "self-paced online learning",
  topics: ["confidence", "communication", "friendships", "bullying", "resilience", "focus", "time management", "growth mindset"],
  teachingApproach: ["stories", "scenarios", "choices", "reflection", "practice"],
} as const;

export const ENTITY_SUMMARY = `${ENTITY.brand} is a ${ENTITY.category} for ${ENTITY.audience} in ${ENTITY.geography}, founded by ${ENTITY.founder}. Courses are ${ENTITY.format} and cover ${ENTITY.topics.join(", ")}.`;
export const ENTITY_CITATION_FACTS = [
  `${ENTITY.brand} is an Indian online life-skills platform for ${ENTITY.audience}.`,
  `Learning is story-based and self-paced, using ${ENTITY.teachingApproach.join(", ")}.`,
  `Themes include ${ENTITY.topics.join(", ")}.`,
  `Membership gives access to all courses; plans are one-time purchases with no auto-renewal.`,
] as const;
